import React from "react";
import { AxiosResponse } from "axios";
import { connect } from "react-redux";
import { withRouter, RouteComponentProps } from "react-router";

import { IUserResponse, ISignUpRequest, IUserDTO } from "app/api/types";
import {
  delUserProfile,
  getUserProfiles,
  addUserProfile,
  updateUserProfile
} from "app/api/redux/Users/actions";

import UsersList from "app/components/UsersList";
import LayoutUser from "app/components/LayoutUser";

import "./styles.scss";

interface IProps extends RouteComponentProps<{ id: string }> {
  usersList: IUserResponse[];
  isLoading: boolean;
  getUserProfiles: () => Promise<AxiosResponse>;
  addUserProfile: (data: ISignUpRequest) => Promise<AxiosResponse>;
  delUserProfile: (id: number) => Promise<AxiosResponse>;
  updateUserProfile: (data: IUserDTO) => Promise<AxiosResponse>;
}

class UsersPage extends React.Component<IProps> {
  componentDidMount() {
    this.props.getUserProfiles().catch(err => {
      console.log(err);
      this.props.history.push("/404");
    });
  }

  render() {
    return (
      <LayoutUser>
        <UsersList
          usersList={this.props.usersList}
          isLoading={this.props.isLoading}
          delUserProfile={this.props.delUserProfile}
          getUserProfiles={this.props.getUserProfiles}
          addUserProfile={this.props.addUserProfile}
          updateUserProfile={this.props.updateUserProfile}
        />
      </LayoutUser>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    usersList: state.users.usersList,
    isLoading: state.users.isLoading
  };
};

export default withRouter(
  connect(mapStateToProps, {
    delUserProfile,
    getUserProfiles,
    addUserProfile,
    updateUserProfile
  })(UsersPage)
);
